import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AppSettings } from '../shared/app-settings';
import moment from 'moment';
import 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class timeZoneService {

  showHeader = new BehaviorSubject<boolean>(false);
  hideNavLinks = new BehaviorSubject<boolean>(false);
  private data = new BehaviorSubject<any>(null);
  currentData = this.data.asObservable();
  constructor(private auth: AuthenticationService) {}

  getAPIEndPoint(apiName: string) {
    let localStorageSelectedSite = localStorage.getItem('selectedSite');
    let selectedSite = JSON.parse(localStorageSelectedSite || '{}');
    let apiEndPoints: any = {};
    if (selectedSite == null || selectedSite.url == null) {
      return;
    }
    let param = btoa(selectedSite.url);
    let url = selectedSite.url;
    apiEndPoints['SNAPSHOT_API'] = url+'SnapShot';
    return apiEndPoints[apiName];
  }

getDateParametersByTimeZone(timeZone) {
    let timeZoneData = {};
    let location;
    let displayTZ;
  
    switch (timeZone) {
      case "CT":
        location = 'America/Chicago';
        displayTZ = "CST";
        break;
      case "ET":
        location = 'America/New_York';
        displayTZ = "EST";
        break;
      case "PT":
        location = 'America/Los_Angeles';
        displayTZ = "PST";
        break;
      case "MT":
        location = 'America/Denver';
        displayTZ = "MST";
        break;
      case "AT":
        location = 'America/Anguilla';
        displayTZ = "AST";
        break;
      case "HT":
        location = 'Pacific/Honolulu';
        displayTZ = "HST";
        break;
      case "MT-AZ":
        location = 'America/Phoenix'; // Adjusted for Arizona
        displayTZ = "MST";
        break;
      case "UTC":
        location = 'UTC';
        displayTZ = "UTC";
        break;
      default:
        location = 'America/Chicago';
        displayTZ = "CST";
    }
  
    var currentTime = moment().tz(location).format('YYYY-MM-DD HH:mm:ss');
  
    timeZoneData['currentTime'] = currentTime;
    timeZoneData['location'] = location;
    timeZoneData['timeZone'] = timeZone;
    timeZoneData['displayCode'] = displayTZ;
  
    return timeZoneData;
  }
  

  dateConvertByTimeZone(dbTime: any, oldTZ: any, newTZ: any, format: any) {
    new Date(dbTime).toLocaleString("en-US", {
      "timeZone": newTZ,
      "hour12": false,
      "hour": "numeric",
      "minute": "numeric",
      "second": "numeric"
    })
  }

  convertTZ(date: any, tzString: any) {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
  }

  updateData(uniqueId: any) {
    const newData = this.getDataBasedOnId(uniqueId);
    this.data.next(newData);
  }

  private getDataBasedOnId(uniqueId: any) {
    return { id: uniqueId};
  }
}
